import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getBlogDetailsAsync,
  reset,
  updateBlogAsync,
} from "../../redux/blogSlice";
import ReactQuill from "react-quill";
import { useNavigate, useParams } from "react-router-dom";

const EditBlog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.blogs.detailsLoading);
  const loadingSuccess = useSelector((state) => state.blogs.detailsLoading);
  const blogData = useSelector((state) => state.blogs.blog);
  const { id } = useParams();
  const [image, setBlogImage] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [toDisplay, setToDisplay] = useState(false);
  const [validateBlog, setValidateBlog] = useState(false);
  const [description, setDescription] = useState("");
  const updateSuccess = useSelector((state) => state.blogs.updateSuccess);

  useEffect(() => {
    if (id) {
      dispatch(getBlogDetailsAsync(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      navigate("/blogs");
    }
  }, [dispatch, updateSuccess]);

  useEffect(() => {
    if (blogData) {
      setBlogImage(blogData.image);
      setContent(blogData.content);
      setDescription(blogData.description);
      setTitle(blogData.title);
      setToDisplay(blogData.toDisplay);
    }
  }, [blogData]);

  const uploadBlogImageHandler = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await axios.post("/api/upload", formData, config);

      setBlogImage(data);
    } catch (error) {
      console.error(error);
    }
  };

  const validateBlogFields = async () => {
    if (title === "" || content === "" || image === "") {
      return false;
    } else {
      return true;
    }
  };

  const updateBlog = async () => {
    const validate = await validateBlogFields();
    setValidateBlog(false);
    if (!validate) {
      setValidateBlog(true);
    } else {
      setValidateBlog(false);
      const data = {
        id,
        title,
        description,
        content,
        image,
        toDisplay,
      };
      dispatch(updateBlogAsync(data));
      setTitle("");
      setBlogImage("");
      setContent("");
      setDescription("");
      setToDisplay(false);
      navigate("/blogs");
    }
  };

  const handleChange = (value) => {
    setContent(value);
  };

  if (loading) return <h1>Loading....</h1>;

  return (
    <div>
      <label>Title</label>
      <input
        type="text"
        name="title"
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
      />
      {validateBlog && title.trim() === "" && (
        <small
          style={{
            color: "red",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          Title is Required
        </small>
      )}

      <div>
        <label>Publish</label>
        <input
          type="checkbox"
          checked={toDisplay}
          onClick={() => setToDisplay((prev) => !prev)}
        />
      </div>
      <textarea
        type="text"
        name="title"
        rows={4}
        value={description}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
      />
      <Col md={12}>
        <section className="galleryWrapper">
          <div className="center">
            <input
              type="text"
              placeholder="Please Select Image"
              style={{ display: "none" }}
            />
            <label>
              <i className="fa fa-cloud-upload"></i>
              <br />
              <span>Click to upload Image</span>
              <input
                type="file"
                style={{ display: "none" }}
                onChange={uploadBlogImageHandler}
              />
            </label>
          </div>
          {image && (
            <figure className="preview">
              <img
                src={`${process.env.REACT_APP_IMAGE_PREFIX}${image}`}
                alt=""
              />
            </figure>
          )}
          {validateBlog && image.trim() === "" && (
            <small
              style={{
                color: "red",
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              Image is required
            </small>
          )}

          <div>
            <ReactQuill
              value={content}
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  [
                    { list: "ordered" },
                    { list: "bullet" },
                    { indent: "-1" },
                    { indent: "+1" },
                  ],
                  ["link", "image"],
                  ["clean"],
                ],
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "blockquote",
                "list",
                "bullet",
                "indent",
                "link",
                "image",
              ]}
              onChange={handleChange}
            />
          </div>
          {validateBlog && content.trim() === "" && (
            <small
              style={{
                color: "red",
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              Content is required
            </small>
          )}
          <button
            className="bton bton--primary"
            onClick={(e) => {
              e.preventDefault();
              updateBlog();
            }}
          >
            Update
          </button>
        </section>
      </Col>
    </div>
  );
};

export default EditBlog;
